import { useMemo } from 'react';

import { useAppSelector } from '@verantos-dev/core-annotation-tool';

import { selectAddedConcepts, selectAnnotationAgentConcepts } from '../../state/selector';
import { getAgentConceptsInStep2Order } from '../../utils/getAgentConceptsInStep2Order';

// TODO: cleanup with cp_annotation_createproject_agent ff

export interface ConceptWithNotes {
  conceptGroupId: string;
  name: string;
}

/** The concepts that have saved special notes, in step 2 order. Drafts are not counted. */
export const useAgentValidationPanel = (): ConceptWithNotes[] => {
  const addedConcepts = useAppSelector(selectAddedConcepts);
  const concepts = useAppSelector(selectAnnotationAgentConcepts);

  return useMemo(
    () =>
      getAgentConceptsInStep2Order(addedConcepts, concepts)
        .filter(({ concept }) => concept.notes.trim() !== '')
        .map(({ conceptGroupId, concept }) => ({ conceptGroupId, name: concept.name })),
    [addedConcepts, concepts]
  );
};
